export class ChangePasswordModel {
  email: string | null = null;
  old_password: string | null = null;
  new_password: string | null = null;

  constructor() {}
}
